<script>
	import phoneboxBase from '@_system/components/base/phone/box.vue'
	export default {
		extends: phoneboxBase,
		name: 'box',
		props: {

		},
		data() {
			return {
				// containerId: 'box_' + Math.random(),
				action: '',
				popoverDisabled: true
			}
		},
		watch: {

		},
		created() {
			if (!this.parentControll) {
				this.unlock()
			} else {
				this.popoverDisabled = this.parentControll.props.disabled
			}
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			lock() {
				this.popoverDisabled = true
			},
			unlock() {
				this.popoverDisabled = false
			},
			// setComponent(component) {
			// 	this.component = component
			// 	document.getElementById(this.containerId + '_id').appendChild(component.$el)
			// },
			submit(close) {
		
				if (this.moduleName != '') {
					this.$emit('submit', {
						type: 'add',
						moduleName: this.moduleName,
						boxTable: this.$refs[this.ref],
						data: this.selectType === 'radio' ? this.$refs[this.ref].getRadioRecord() : this.$refs[this
							.ref].getCheckboxRecords(),
					})
				} else {
					this.$emit('submit', {
						boxTable: this.$refs[this.ref],
						data: this.component.$refs[this.component.gridref].getTableData(),
					})

				}
				this.close(close)
			},
			submitwidthreflash(data) {
				this.$emit('submit', {
					type: 'flash',
					moduleName: this.moduleName,
					boxTable: null,
					data: data
				})
			},
			hide() {
				if (this.moduleName == '') {
					this.$emit('submit', {
						boxTable: this.$refs[this.ref],
						data: this.component.$refs[this.component.gridref].getTableData()
					})
				}
				this.opacity = 1
			}

		},
		components: {

		}
	}
</script>
